import request from '@/API/request';

// 获取处罚列表
export function getPunishmentList(data) {
  return request({
    url: '/resource/api/punishment/list/pagedata',
    method: 'get',
    params: data,
  });
}
// 获取站点信息
export function getStations() {
  return request({
    url: '/resource/api/station/selection/list',
    method: 'get',
  });
}
// 新增处罚信息
export function addPunishment(data) {
  return request({
    url: '/resource/api/punishment',
    method: 'post',
    data,
  });
}
// 趋势图数据
export function getPunishmentTrend(data) {
  return request({
    url: '/resource/api/punishment/trend',
    method: 'get',
    params: data,
  });
}
